import { FC, ReactNode } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import BaseAddress, { BaseAddressProps } from 'components/forms/HomeAddress/Common2HomeAddress/BaseAddress';
import type { FormCheckType } from 'types/common';
import type { CustomerInfoKeyType } from 'types/customer';
import DeliveryCountry from '../components/DeliveryCountry';
import { BaseDeliveryAddressProps, DeliveryAddressTypeEnum } from '../type';

export interface Common2DeliveryAddressFormutil {
    delivery_detail: string;
    delivery_detail2: string;
    delivery_city: string;
    delivery_state_code: string;
    delivery_postal: string;
    delivery_country: string;
    delivery_address_type: DeliveryAddressTypeEnum;
}

export interface Common2DeliveryAddressProps extends Omit<BaseAddressProps, 'prefix'>, BaseDeliveryAddressProps {
    title?: ReactNode;
}

/**
 * @description 获取邮寄地址对应的默认表单项字段的数组
 * @param sameDeliveryAndResidence same_delivery_and_residence，我的邮寄地址与居住地址不同对应的字段
 */
export function getFieldsOfCommon2DeliveryAddress(
    sameDeliveryAndResidence: FormCheckType | undefined,
    needDeliveryAddressType: boolean = true
) {
    const baseFields: CustomerInfoKeyType[] =
        sameDeliveryAndResidence === '0'
            ? [
                  'delivery_detail',
                  'delivery_detail2',
                  'delivery_city',
                  'delivery_state_code',
                  'delivery_postal',
                  'delivery_country'
              ]
            : [];

    return needDeliveryAddressType ? baseFields.concat('delivery_address_type') : baseFields;
}

/** common2 邮寄地址类型，目前用于加拿大 */
const Common2: FC<Common2DeliveryAddressProps> = ({
    title = __('MAILING ADDRESS'),
    hasCountry,
    disabled,
    deliveryCountry,
    ...restProps
}) => {
    return (
        <>
            {title && <h3 className="open-title mt-4">{title}</h3>}
            {hasCountry && <DeliveryCountry $defaultValue={deliveryCountry} disabled={disabled} />}
            <BaseAddress
                prefix="delivery"
                hideMailAddress
                label={null}
                disabled={disabled}
                legalResidenceCountry={deliveryCountry}
                {...restProps}
            />
            <EasyField name="delivery_address_type" type="hidden" $defaultValue={DeliveryAddressTypeEnum.COMMON2} />
        </>
    );
};

export default Common2;
